import { Box, Typography } from "@mui/material";
import useColors from "api/hooks/useColors";
import StyledDataGrid from "components/StyledDataGrid";

const AssignmentsUsageWidget = ({ customers, isLoading }) => {
  const colors = useColors();

  const customersWithAssignees = (customers || [])
    .filter((c) => c.controls_with_assignees_count > 0)
    .sort(
      (a, b) =>
        b.controls_with_assignees_count - a.controls_with_assignees_count
    );

  const customersWithoutAssignees = (customers || []).filter(
    (c) =>
      !c.controls_with_assignees_count || c.controls_with_assignees_count === 0
  );

  const columns = [
    {
      field: "customer_id",
      headerName: "Customer ID",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontSize: "13px" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "env_id",
      headerName: "Environment",
      flex: 0.8,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontSize: "13px" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "controls_with_assignees_count",
      headerName: "Assigned Controls",
      flex: 0.7,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "13px",
            color: params.value > 0 ? colors.success : colors.text_secondary,
            fontWeight: params.value > 0 ? 600 : 400,
          }}
        >
          {params.value || 0}
        </Typography>
      ),
    },
    {
      field: "controls_count",
      headerName: "Total Controls",
      flex: 0.6,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontSize: "13px" }}>
          {params.value}
        </Typography>
      ),
    },
  ];

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column", gap: 2 }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
          padding: "8px 0",
          borderBottom: `1px solid ${colors.divider2}`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: colors.success,
            }}
          />
          <Typography variant="body2" sx={{ fontSize: "13px" }}>
            Using Assignments: {customersWithAssignees.length}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: colors.text_secondary,
            }}
          />
          <Typography variant="body2" sx={{ fontSize: "13px" }}>
            Not Using: {customersWithoutAssignees.length}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0 }}>
        <StyledDataGrid
          rows={[...customersWithAssignees, ...customersWithoutAssignees].map(
            (customer, idx) => ({
              id: idx,
              ...customer,
            })
          )}
          columns={columns}
          loading={isLoading}
          disableRowSelectionOnClick
          pageSizeOptionsOverride={[10, 25, 50]}
          autoHeight={false}
          boxSXProps={{ height: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default AssignmentsUsageWidget;
